
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webp-to-jpeg-converter",
      function () {
        return require("private-next-pages/webp-to-jpeg-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webp-to-jpeg-converter"])
      });
    }
  